<script setup lang="ts">
</script>

<!-- eslint-disable -->
<template>
    <svg width="609" height="406" viewBox="0 0 609 406" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.1">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M92.7458 30.9543C75.1418 54.5552 83.2682 82.6847 66.702 130.6C50.1358 178.515 7.37537 163.555 0.611328 246.081C0.611328 318.717 14.039 330.387 40.2217 358.07C66.4044 385.753 131.992 414.655 219.505 403.293C307.017 391.93 317.066 358.07 386.452 358.07C455.837 358.07 494.356 375.331 536.561 358.07C578.766 340.809 630.658 284.609 599.494 222.097C536.561 112.33 461.258 187.309 403.663 156.937C346.069 126.565 345.633 106.952 309.55 70.3636C273.468 33.7751 244.814 5.02855 189.648 0.879143C134.483 -3.27026 110.35 7.35335 92.7458 30.9543Z" fill="#D96DFF"/>
        </g>
    </svg>
</template>
<!-- eslint-enable -->
